import React from 'react';
import TextField from '@mui/material/TextField';
import { getAirItemTypeLabel } from '../utils/airItemTypeUtils';

/**
 * Renders inputs for a list of air item types: per_item → qty, per_kg → weight (kg).
 * items: array of { id, airItemType: { id, typeName, category, type, calculationMethod }, weightKg?, qty? }
 * onWeightChange(id, value), onQtyChange(id, value)
 * singlePerKgBoxWeight: when there is exactly one per_kg item, use this as weight (no input) — e.g. box weight
 */
const AirItemTypeInputs = ({ items = [], onWeightChange, onQtyChange, disabled = false, size = 'small', singlePerKgBoxWeight = null }) => {
  const perItemList = items.filter((item) => item.airItemType?.calculationMethod === 'per_item');
  const perKgList = items.filter((item) => item.airItemType?.calculationMethod === 'per_kg');
  const useBoxWeightForSinglePerKg = perKgList.length === 1 && singlePerKgBoxWeight != null && singlePerKgBoxWeight !== '';

  return (
    <div className="space-y-3">
      {perItemList.length > 0 && (
        <div>
          <span className="text-xs font-medium text-green-700 block mb-1">ต่อชิ้น — จำนวน</span>
          <div className="flex flex-wrap gap-x-4 gap-y-2">
            {perItemList.map((item) => (
              <div key={item.id ?? `type-${item.airItemTypeId ?? item.airItemType?.id}`} className="flex items-center gap-2">
                <span className="text-sm text-gray-700">{getAirItemTypeLabel(item.airItemType)}</span>
                <TextField
                  size={size}
                  type="number"
                  value={item.qty ?? ''}
                  onChange={(e) => onQtyChange && onQtyChange(item.id ?? item.airItemTypeId, e.target.value)}
                  placeholder="0"
                  inputProps={{ min: 0 }}
                  sx={{ width: 70 }}
                  disabled={disabled}
                />
              </div>
            ))}
          </div>
        </div>
      )}
      {perKgList.length > 0 && (
        <div>
          <span className="text-xs font-medium text-amber-700 block mb-1">ต่อกิโล — น้ำหนัก (kg)</span>
          <div className="flex flex-wrap gap-x-4 gap-y-2">
            {perKgList.map((item) => (
              <div key={item.id ?? `type-${item.airItemTypeId ?? item.airItemType?.id}`} className="flex items-center gap-2">
                <span className="text-sm text-gray-700">{getAirItemTypeLabel(item.airItemType)}</span>
                {useBoxWeightForSinglePerKg ? (
                  <span className="text-sm text-amber-800 font-medium">ใช้น้ำหนักกล่อง: {Number(singlePerKgBoxWeight)} kg</span>
                ) : (
                  <TextField
                    size={size}
                    type="number"
                    value={item.weightKg ?? ''}
                    onChange={(e) => onWeightChange && onWeightChange(item.id ?? item.airItemTypeId, e.target.value)}
                    placeholder="kg"
                    inputProps={{ min: 0, step: 0.1 }}
                    sx={{ width: 80 }}
                    disabled={disabled}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AirItemTypeInputs;
export { getAirItemTypeLabel };
